import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function JobSeekerDashboard() {
  return (

        <div className="content-body">
          <section className="container my-5">
    <div className="search text-center">
      <form className="form-row justify-content-center">
        <div className="col-md-3 mb-2">
          <input type="text" className="form-control" placeholder="Search by Position"/>
        </div>
        <div className="col-md-3 mb-2">
          <input type="text" className="form-control" placeholder="Company"/>
        </div>
        <div className="col-md-2 mb-2">
          <button type="submit" className="btn btn-success btn-block">Filter</button>
        </div>
      </form>
    </div>
  </section>

  <section className="container">
    <h2 className="mb-4 text-center">Applications List</h2>
    <div className="row">
      <div className="col-md-6">
        <div className="card mb-4">
          <div className="card-body">
            <h4 className="card-title">Frontend Developer</h4>
            <p className="card-text">Company: Acme Technologies</p>
            <p className="card-text">Applied on: 2025-09-07</p>
            <span className="badge badge-info">Status: In Review</span>
            <div className="mt-3">
              <a href="#" className="btn btn-primary btn-sm">View Details</a>
              <a href="#" className="btn btn-danger btn-sm">Withdraw</a>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <div className="card mb-4">
          <div className="card-body">
            <h4 className="card-title">UI Designer</h4>
            <p className="card-text">Company: VisualX</p>
            <p className="card-text">Applied on: 2025-08-22</p>
            <span className="badge badge-success">Status: Shortlisted</span>
            <div className="mt-3">
              <a href="#" className="btn btn-primary btn-sm">View Details</a>
              <a href="#" className="btn btn-danger btn-sm">Withdraw</a>
            </div>
          </div>
        </div>
      </div>
  
    </div>
  </section>
        </div>
      
  );
}

export default JobSeekerDashboard;
